export default __webpack_public_path__ + "5c37ccf4fd7d6622ab604ecd7fb0fb8d.webp";